<template>
  <popper
    v-bind="optionsComputed"
  >
    <div
      class="popper"
    >
      {{ options.content }}
    </div>
    <slot
      slot="reference"
    />
  </popper>
</template>
<script>
import Popper from 'vue-popperjs'
export default {
  props: {
    options: {
      type: Object,
      default: () => {
        return {
          options: {
            placement: 'top'
          }
        }
      }
    }
  },
  components: {
    Popper
  },
  computed: {
    optionsComputed() {
      let options = _.cloneDeep(this.options.options)
      if (!options.modifiers) {
        options.modifiers = {
          offset: {
            offset: '0,5px',
            arrow: '0,5px'
          },
        }
      }
      if (!options.placement) {
        options.placement = 'top'
      }
      return {
        'data-value': this.options.content,
        'visible-arrow': true,
        options: options
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.popper
  background: #FFF
  padding: 5px 10px
  border: 1px solid $paper
  border-radius: 5px
  z-index: 100
  text-align: center
</style>
<style lang="sass">
.popper__arrow
  width: 0
  height: 0
  border-style: solid
  border-width: 8px 8px 0 8px
  border-color: $paper transparent transparent transparent
  position: absolute
  margin: 5px
</style>



// WEBPACK FOOTER //
// PopOver.vue?26cddd30